import { useEffect, useState } from "react";
import { delete_user, get_userLoginData } from "../services/api";
import { useNavigate } from "react-router-dom";

const Profile: React.FC = () => {
  const [profile, setProfile] = useState<any>("");
  const [deleteAccountLoading, setDeleteAccountLoading] = useState<any>(false);
const navigate = useNavigate();
  useEffect(() => {
    const profileData = JSON.parse(localStorage.getItem("profile") || "{}");
    console.log("profile", profileData);
    setProfile(profileData.userData);
  }, []);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete your account?")) {
      setDeleteAccountLoading(true);
     
      const body = {
        id: profile.id,
      };
      console.log("body", body);
     
      await delete_user(body).then(
        async (res) => {
          console.log(res.data.status);
          if (res.data.status === true) {
           localStorage.removeItem("profile");
           localStorage.setItem("isLogin", "false");
            
            setDeleteAccountLoading(false);
           
            navigate("/");
            window.location.reload();
           
          } else {
            console.log('user not deleted');
          }
        },
        (err) => {
         
          setDeleteAccountLoading(false);
          console.log("error in delete box", err);
          console.log('Something went wrong');
        }
      );
    }
  };
  
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-start">
      {/* Logout button top-right */}
    {/* <div className="w-full flex justify-end pr-6 pt-4">
      <button
        onClick={handleLogout}
        className="bg-gradient-to-r from-black to-red-700 hover:opacity-90 text-white px-4 py-2 rounded-lg font-semibold transition"
      >
        Logout
      </button>
    </div> */}
      <p className="text-center text-2xl mt-8">Profile</p>

      <div className="h-[100px] w-[100px] rounded-full overflow-hidden flex items-center justify-center mt-2 mb-5 ">
        <img
          src={profile.image ? profile.image : "/user.png"}
          alt="User"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="grid gap-6 mb-6 md:grid-cols-1 items-center   w-[80%] md:w-[50%] lg:w-[30%]">
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Name
          </label>
          <input
            value={profile.name ? profile.name : ""}
            id="disabled-input"
            aria-label="disabled input"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            disabled
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Email
          </label>
          <input
            value={profile.email ? profile.email : ""}
            id="disabled-input"
            aria-label="disabled input"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            disabled
          />
        </div>
        {profile.address?
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Address
          </label>
          <input
            value={profile.address ? profile.address : ""}
            id="disabled-input"
            aria-label="disabled input"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            disabled
          />
        </div>
          :""}
        <button
          onClick={handleDelete}
          disabled={deleteAccountLoading}
          //className="text-white  bg-red-600 hover:bg-red-700   font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
       
       
          className={`flex items-center justify-center gap-2  mt-9  mb-9 text-white py-3 rounded-lg transition-all ${
            deleteAccountLoading
              ? "bg-gray-500 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700"
          }`}
       >
          
          {deleteAccountLoading && (
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {deleteAccountLoading ? "Deleting..." : "Delete Account"}
        </button>
      </div>
    </div>
  );
};
export default Profile;
